var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOffers = function SvgOffers(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 10,
    "data-width-16": 13,
    "data-width-20": 16,
    "data-width-24": 19,
    "data-width-28": 22,
    "data-width-72": 56,
    viewBox: "0 0 9.3 9.3",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.883 8.891a2 2 0 0 0 1.104.341 2 2 0 0 0 1.435-.585l2.05-2.05a1.76 1.76 0 0 0 2.145-.24l1.12-1.125a1.725 1.725 0 0 0 0-2.435l-.19-.19a.37.37 0 0 0-.53 0L6.682 3.922a.445.445 0 0 1-.615 0l-.765-.765a.435.435 0 0 1 0-.615l1.315-1.335a.37.37 0 0 0 .02-.53l-.19-.19a1.765 1.765 0 0 0-2.435 0L2.867 1.632a1.735 1.735 0 0 0-.25 2.145l-2.04 2.05a2 2 0 0 0 .306 3.064M4.855.805a1 1 0 0 1 .372-.073.96.96 0 0 1 .61.205L4.772 2.002a1.19 1.19 0 0 0 0 1.675l.765.765a1.22 1.22 0 0 0 1.675 0l1.065-1.065a.97.97 0 0 1-.07 1.295L7.062 5.817a.97.97 0 0 1-1.375 0 .375.375 0 0 0-.53 0l-2.29 2.29a1.245 1.245 0 0 1-1.75-1.75l2.285-2.285a.38.38 0 0 0 0-.535.95.95 0 0 1-.285-.685.97.97 0 0 1 .28-.69l1.145-1.145a1 1 0 0 1 .313-.212M1.843 7.579a.4.4 0 0 0 .144.028.37.37 0 0 0 .265-.105l1.905-1.895a.382.382 0 0 0-.54-.54l-1.895 1.9a.37.37 0 0 0 0 .53.4.4 0 0 0 .12.082",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOffers);
export default ForwardRef;